// React
import React from 'react';
import {
  Col,
  Nav,
  Row,
  Card,
  Form,
  Label,
  Input,
  NavItem,
  NavLink,
  TabPane,
  CardBody,
  Container,
  CardHeader,
  CardFooter,
  TabContent,
} from 'reactstrap';

// Containers Injections
import {
  InputPhone,
  InputCpfCnpj,
  ZipCodeInput,
  LoadingScreen,
  SelectInputWithSearchApi,
  PageWrapper,
} from '../../containers/componentsInjection';

// Views
import CardSpecialties from './views/CardSpecialties';
import { CardUploadFiles } from './views/CardUploadFiles';
import { VisitSchedule } from './views/CardVisitSchedule';

// Utils
import classnames from 'classnames';
import { getBase64 } from '../../utils/fileFormatting';
import { resetCpfCnpjInput } from '../../utils/validation/reset';

// assets
import user_pick from '../../../../assets/images/users/user-pic.jpg';

export const CredentialsNTFormPage = ({
  history,
  tabChange,
  updatedAt,
  credential,
  validation,
  // states
  logo,
  check,
  image,
  loading,
  isUpdate,
  isActive,
  typeMask,
  setImage,
  setCheck,
  activeTab,
  setIsActive,
  setTypeMask,
  credentialName,
  credentialEmail,
}) => {
  return (
    <LoadingScreen loading={loading}>
      <PageWrapper
        title={isUpdate ? 'Editar Rede Credenciada' : 'Nova Rede Credenciada'}
      >
        <Row>
          {isUpdate && (
            <Col xxl={3}>
              <Card>
                <CardBody className="p-4">
                  <div className="text-center">
                    <div className="profile-user position-relative d-inline-block mx-auto  mb-4">
                      {}
                      <img
                        src={logo ? logo : image ? image : user_pick}
                        className="rounded-circle avatar-xl img-thumbnail user-profile-image"
                        alt="user-profile"
                      />
                      <div className="avatar-xs p-0 rounded-circle profile-photo-edit">
                        <Input
                          id="profile-img-file-input"
                          type="file"
                          className="profile-img-file-input"
                          onChange={(e) => {
                            if (
                              e.target.files[0].type === 'image/jpeg' ||
                              e.target.files[0].type === 'image/jpg' ||
                              e.target.files[0].type === 'image/png'
                            ) {
                              getBase64(e.target.files[0]).then((data) => {
                                setImage(data);
                              });
                            } else {
                              alert('Formato inválido');
                            }
                          }}
                        />
                        <Label
                          htmlFor="profile-img-file-input"
                          className="profile-photo-edit avatar-xs"
                        >
                          <span className="avatar-title rounded-circle bg-light text-body">
                            <i className="ri-camera-fill"></i>
                          </span>
                        </Label>
                      </div>
                    </div>
                    <h5 className="fs-16 mb-1">{credentialName || ''}</h5>
                    <p className="text-muted mb-0">{credentialEmail || ''}</p>
                  </div>
                </CardBody>
              </Card>
            </Col>
          )}

          <Col xxl={isUpdate ? 9 : 12}>
            <Card>
              <CardHeader>
                <Nav
                  className="nav-tabs-custom rounded card-header-tabs border-bottom-0"
                  role="tablist"
                >
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '1' })}
                      onClick={() => {
                        tabChange('1');
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      <i className="fas fa-home"></i>
                      Dados Cadastrais
                    </NavLink>
                  </NavItem>
                  <TabPane>
                    <NavItem>
                      <NavLink
                        to="#"
                        className={classnames({ active: activeTab === '2' })}
                        disabled={!isUpdate}
                        onClick={() => {
                          tabChange('2');
                        }}
                        type="button"
                      >
                        <i className="far fa-user"></i>
                        Especialidades
                      </NavLink>
                    </NavItem>
                  </TabPane>
                  <NavItem>
                    <NavLink
                      to="#"
                      className={classnames({ active: activeTab === '3' })}
                      disabled={!isUpdate}
                      onClick={() => {
                        tabChange('3');
                      }}
                      type="button"
                    >
                      <i className="far fa-user"></i>
                      Agenda de Visitas
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      to="#"
                      className={classnames({ active: activeTab === '4' })}
                      disabled={!isUpdate}
                      onClick={() => {
                        tabChange('4');
                      }}
                      type="button"
                    >
                      <i className="far fa-user"></i>
                      Arquivos
                    </NavLink>
                  </NavItem>
                </Nav>
              </CardHeader>

              <TabContent activeTab={activeTab}>
                <TabPane tabId="1">
                  <Form
                    autoComplete="off"
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <CardBody className="p-4">
                      <Row>
                        <Col md={12}>
                          <div className="mb-3">
                            <h5>Principal</h5>
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="mb-3">
                            <Label htmlFor="name" className="form-label">
                              Pessoa
                            </Label>
                            <Input
                              id="people"
                              type="select"
                              className="form-select"
                              onChange={(e) => {
                                resetCpfCnpjInput(validation);
                                setTypeMask(e.target.value);
                              }}
                              defaultValue={typeMask}
                            >
                              <option value="CPF">Física</option>
                              <option value="CNPJ">Jurídica</option>
                            </Input>
                          </div>
                        </Col>

                        <Col md={4}>
                          <div className="mb-3">
                            <label
                              htmlFor="cleave-delimiters"
                              className="form-label"
                            >
                              {typeMask === 'CPF' ? 'CPF' : 'CNPJ'}
                            </label>
                            <InputCpfCnpj
                              id="cpfInput"
                              isCPF={typeMask === 'CPF'}
                              value={validation.values.cpfInput || ''}
                              onChange={
                                typeMask === 'CPF'
                                  ? (e, type) => {
                                      // to limit the possibility of entering more numbers when it is CPF
                                      if (type === 'CPF') {
                                        validation.handleChange(e);
                                      }
                                    }
                                  : (e) => {
                                      validation.handleChange(e);
                                    }
                              }
                              onBlur={validation.handleBlur}
                              invalid={
                                !!(
                                  validation.touched.cpfInput &&
                                  validation.errors.cpfInput
                                )
                              }
                            />
                            {validation.touched.cpfInput &&
                            validation.errors.cpfInput ? (
                              <p className="labelErrorValidation">
                                {validation.errors.cpfInput &&
                                  `Digite um ${typeMask} válido`}
                              </p>
                            ) : null}
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="mb-3">
                            <Label htmlFor="name" className="form-label">
                              Nome
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="nameInput"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.nameInput || ''}
                            />
                            {validation.touched.nameInput &&
                            validation.errors.nameInput ? (
                              <p className="labelErrorValidation">
                                {validation.errors.nameInput}
                              </p>
                            ) : null}
                          </div>
                        </Col>

                        <Col md={12}>
                          <div className="mb-3">
                            <Label
                              htmlFor="address1ControlTextarea"
                              className="form-label"
                            >
                              Observações
                            </Label>
                            <textarea
                              className="form-control"
                              id="obsInput"
                              rows="3"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.obsInput || ''}
                            ></textarea>
                          </div>
                        </Col>
                        <Col md={12}>
                          <div className="mb-3">
                            <h5>Contato</h5>
                          </div>
                        </Col>

                        <Col md={4}>
                          <div className="mb-3">
                            <Label
                              htmlFor="contactInput"
                              className="form-label"
                            >
                              Nome do Contato
                            </Label>
                            <Input
                              className="form-control"
                              id="contactInput"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.contactInput || ''}
                            />
                            {validation.touched.contactInput &&
                            validation.errors.contactInput ? (
                              <p className="labelErrorValidation">
                                {validation.errors.contactInput}
                              </p>
                            ) : null}
                          </div>
                        </Col>

                        <Col md={4}>
                          <div className="mb-3">
                            <Label
                              htmlFor="citynameInput"
                              className="form-label"
                            >
                              Celular
                            </Label>
                            <InputPhone
                              id="phone1Input"
                              name="phone1Input"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.phone1Input || ''}
                            />
                            {validation.touched.phone1Input &&
                            validation.errors.phone1Input ? (
                              <p className="labelErrorValidation">
                                {validation.errors.phone1Input}
                              </p>
                            ) : null}
                          </div>
                        </Col>

                        <Col md={4}>
                          <div className="mb-3">
                            <Label
                              htmlFor="citynameInput"
                              className="form-label"
                            >
                              Telefone
                            </Label>
                            <InputPhone
                              id="phone2Input"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.phone2Input || ''}
                            />
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="mb-3">
                            <Label
                              htmlFor="citynameInput"
                              className="form-label"
                            >
                              Email
                            </Label>
                            <Input
                              type="email"
                              className="form-control"
                              id="emailInput"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.emailInput || ''}
                            />
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="mb-3">
                            <Label
                              htmlFor="citynameInput"
                              className="form-label"
                            >
                              Whatsapp
                            </Label>
                            <InputPhone
                              id="whatsappInput"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.whatsappInput || ''}
                            />
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="mb-3">
                            <Label htmlFor="siteInput" className="form-label">
                              Site
                            </Label>
                            <Input
                              type="text"
                              id="siteInput"
                              className="form-control"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.siteInput || ''}
                            />

                            <Col lg={4} md={6}>
                              <div className="mt-3">
                                <div
                                  className="form-check form-switch form-switch-lg form-switch-success mb-3"
                                  dir="ltr"
                                >
                                  <Input
                                    type="checkbox"
                                    checked={check}
                                    role="switch"
                                    className="form-check-input"
                                    id="isOnlineService"
                                    name="isOnlineService"
                                    onChange={() => setCheck(!check)}
                                    onRateChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                  />
                                  <Label
                                    className="form-check-label"
                                    for="customSwitchsizelg"
                                  >
                                    Serviço Online
                                  </Label>
                                </div>
                              </div>
                            </Col>
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="mb-3">
                            <Label
                              htmlFor="instagramInput"
                              className="form-label"
                            >
                              Instagram
                            </Label>
                            <Input
                              type="text"
                              id="instagramInput"
                              className="form-control"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.instagramInput || ''}
                            />
                          </div>
                        </Col>

                        {!validation.values.isOnlineService && (
                          <>
                            <Col md={12}>
                              <div className="mb-3">
                                <h5>Endereço</h5>
                              </div>
                            </Col>
                            <Col md={3}>
                              <div className="mb-3">
                                <Label
                                  htmlFor="ForminputState"
                                  className="form-label"
                                >
                                  CEP
                                </Label>
                                <ZipCodeInput
                                  className="form-control"
                                  id="zipInput"
                                  changeInputs={(e) => {
                                    validation.setValues({
                                      ...validation.values,
                                      zipInput: e.cep,
                                      streetInput: e.logradouro,
                                      neighborhoodInput: e.bairro,
                                      address2Input: e.complemento,
                                      cityInput: {
                                        label: `${e.localidade} - ${e.uf} `,
                                        value: e.ibge,
                                      },
                                    });
                                  }}
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.zipInput || ''}
                                />
                                {validation.touched.zipInput &&
                                validation.errors.zipInput ? (
                                  <p className="labelErrorValidation">
                                    {validation.errors.zipInput}
                                  </p>
                                ) : null}
                              </div>
                            </Col>

                            <Col md={6}>
                              <div className="mb-3">
                                <Label
                                  htmlFor="ForminputState"
                                  className="form-label"
                                >
                                  Logradouro
                                </Label>
                                <Input
                                  className="form-control"
                                  id="streetInput"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.streetInput || ''}
                                />
                                {validation.touched.streetInput &&
                                validation.errors.streetInput ? (
                                  <p className="labelErrorValidation">
                                    {validation.errors.streetInput}
                                  </p>
                                ) : null}
                              </div>
                            </Col>

                            <Col md={3}>
                              <div className="mb-3">
                                <Label
                                  htmlFor="ForminputState"
                                  className="form-label"
                                >
                                  Número
                                </Label>
                                <Input
                                  className="form-control"
                                  id="numberInput"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.numberInput || ''}
                                  maxLength="10"
                                />
                                {validation.touched.numberInput &&
                                validation.errors.numberInput ? (
                                  <p className="labelErrorValidation">
                                    {validation.errors.numberInput}
                                  </p>
                                ) : null}
                              </div>
                            </Col>

                            <Col md={6}>
                              <div className="mb-3">
                                <Label
                                  htmlFor="ForminputState"
                                  className="form-label"
                                >
                                  Complemento
                                </Label>
                                <Input
                                  className="form-control"
                                  id="address2Input"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.address2Input || ''}
                                />
                              </div>
                            </Col>

                            <Col md={6}>
                              <div className="mb-3">
                                <Label
                                  htmlFor="ForminputState"
                                  className="form-label"
                                >
                                  Bairro
                                </Label>
                                <Input
                                  className="form-control"
                                  id="neighborhoodInput"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={
                                    validation.values.neighborhoodInput || ''
                                  }
                                />
                                {validation.touched.neighborhoodInput &&
                                validation.errors.neighborhoodInput ? (
                                  <p className="labelErrorValidation">
                                    {validation.errors.neighborhoodInput}
                                  </p>
                                ) : null}
                              </div>
                            </Col>

                            <Col md={6}>
                              <div className="mb-3">
                                <Label
                                  htmlFor="cityInput"
                                  className="form-label"
                                >
                                  Cidade
                                </Label>
                                <SelectInputWithSearchApi
                                  validation={validation}
                                />
                                {validation.touched.cityInput &&
                                validation.errors.cityInput ? (
                                  <p className="labelErrorValidation">
                                    {validation.errors.cityInput}
                                  </p>
                                ) : null}
                              </div>
                            </Col>

                            <Col lg={12} md={12}>
                              <div className="mt-4 mt-md-0">
                                <div>
                                  <div className="form-check form-switch form-check-right mb-2">
                                    <Input
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      id="isActiveSelect"
                                      onChange={() => setIsActive(!isActive)}
                                      onBlur={validation.handleBlur}
                                      checked={isActive}
                                    />
                                    <Label
                                      className="form-check-label"
                                      htmlFor="flexSwitchCheckRightDisabled"
                                    >
                                      Ativo
                                    </Label>
                                  </div>
                                </div>
                              </div>
                            </Col>
                          </>
                        )}
                      </Row>
                    </CardBody>
                    <CardFooter className="mt-3">
                      <Col md={12}>
                        <div className="d-flex align-items-center justify-content-between">
                          <span className="card-text">
                            <small className="text-muted" hidden={!isUpdate}>
                              {updatedAt}
                            </small>
                          </span>
                          <div className="text-end d-flex justify-content-end">
                            <button
                              type="button"
                              className="btn btn-link"
                              style={{
                                marginRight: '10px',
                              }}
                              onClick={() => {
                                history.push('/rede-credenciada');
                              }}
                            >
                              Cancelar
                            </button>
                            <button type="submit" className="btn btn-primary">
                              Salvar
                            </button>
                          </div>
                        </div>
                      </Col>
                    </CardFooter>
                  </Form>
                </TabPane>

                <TabPane tabId="2">
                  <CardBody className="p-4">
                    <CardSpecialties credential={credential} />
                  </CardBody>
                </TabPane>

                <TabPane tabId="3">
                  <CardBody className="p-4">
                    <VisitSchedule credential={credential} />
                  </CardBody>
                </TabPane>

                <TabPane tabId="4">
                  <CardBody className="p-4">
                    <CardUploadFiles credential={credential} />
                  </CardBody>
                </TabPane>
              </TabContent>
            </Card>
          </Col>
        </Row>
      </PageWrapper>
    </LoadingScreen>
  );
};
